import {WidgetResourcesSection} from "../../organisms/widget--resources-section";

/**
 * Displays a document library widget.
 *
 * @param paragraph
 *   The paragraph.
 * @param props
 *   Additional properties.
 * @constructor
 */
export function ParagraphDocumentLibrary ({paragraph, ...props}) {
  if (!paragraph?.field_document_library_docs) return <></>

  return (
    <WidgetResourcesSection documents={paragraph.field_document_library_docs} />
  )
}